import setupStore from '@app/setup-store';

const store = setupStore();
export default store;
